(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tobie-age-gate"]) return;
  try {
    
  (() => {
    const gate = document.querySelector('.tobie-age-gate:not([data-tobie-age-bound])');
    if (!gate) return;
    gate.dataset.tobieAgeBound = 'true';

    const key = gate.dataset.storageKey || 'tobie-age-verified';
    const expiryDays = parseInt(gate.dataset.expiryDays || '30', 10);
    const enterButton = gate.querySelector('[data-tobie-age-enter]');

    // Check localStorage with configurable expiry
    try {
      const stored = localStorage.getItem(key);
      if (stored) {
        const data = JSON.parse(stored);
        if (data.verified && data.expiresAt && Date.now() < data.expiresAt) {
          gate.hidden = true;
          return;
        }
      }
    } catch (error) {
      // Fallback: if localStorage is disabled or corrupted, proceed to prompt
    }

    document.body.classList.add('tobie-age-gate-open');
    enterButton?.focus();

    enterButton?.addEventListener('click', () => {
      try {
        const expiresAt = Date.now() + expiryDays * 24 * 60 * 60 * 1000;
        localStorage.setItem(key, JSON.stringify({ verified: true, expiresAt }));
      } catch (error) {}

      gate.classList.add('is-leaving');
      document.body.classList.remove('tobie-age-gate-open');
      window.setTimeout(() => { gate.hidden = true; }, 700);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tobie-lifestyle"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('.tobie-lifestyle[data-tobie-reveal]:not([data-tobie-bound])');

    sections.forEach((section) => {
      section.dataset.tobieBound = 'true';

      // Reveal on scroll — fade + translateY, fires once.
      if ('IntersectionObserver' in window) {
        const revealObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                section.classList.add('is-visible');
                revealObserver.unobserve(section);
              }
            });
          },
          { threshold: 0.3 }
        );
        revealObserver.observe(section);
      } else {
        section.classList.add('is-visible');
      }

      // Pause offscreen video for performance; resume on re-entry.
      const videos = section.querySelectorAll('video');
      if (videos.length && 'IntersectionObserver' in window) {
        const videoObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              const video = entry.target;
              if (entry.isIntersecting) {
                video.play().catch(() => {});
              } else {
                video.pause();
              }
            });
          },
          { threshold: 0.1 }
        );
        videos.forEach((video) => videoObserver.observe(video));
      }

      // Gentle scroll-linked parallax on the image/video frame. GPU-only
      // (transform), reads with rAF to avoid layout thrash.
      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const frame = section.querySelector('.tobie-lifestyle__frame');
      if (!frame || prefersReducedMotion) return;

      let ticking = false;
      const updateParallax = () => {
        const rect = frame.getBoundingClientRect();
        const viewportH = window.innerHeight || document.documentElement.clientHeight;
        const progress = (rect.top + rect.height / 2 - viewportH / 2) / viewportH;
        const offset = Math.max(-1, Math.min(1, progress)) * -14;
        frame.style.transform = `translate3d(0, ${offset}px, 0)`;
        ticking = false;
      };

      window.addEventListener(
        'scroll',
        () => {
          if (!ticking) {
            window.requestAnimationFrame(updateParallax);
            ticking = true;
          }
        },
        { passive: true }
      );

      updateParallax();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
